// extracted by mini-css-extract-plugin
var _1 = "SearchEmpty-moduleSearchEmpty__bM96T";
var _2 = "SearchEmpty-moduleicon__DCdwF IconNG-moduleiconContainer__SxWZ0";
var _3 = "SearchEmpty-moduletext__S7_Mf";
export { _1 as "SearchEmpty", _2 as "icon", _3 as "text" }
